import { queryApi } from '@/graphql/query'
import { useLazyQuery } from '@vue/apollo-composable'
import { useStore } from 'vuex'
import * as types from '@/store/modules/common/mutation-type'
import { OpenStatus, RouterName } from '@/enum'
import { useRouter } from 'vue-router'
import * as storage from '@/utils/storage'
import { ref } from 'vue'

export enum Form {
  LAYOUT,
  HOME
}

export const useClientFormDraftAll = (from: number, type: string, applicationStatus?: number) => {
  const router = useRouter()
  const store = useStore()
  const formName = ref('')
  const isShowView = ref(false)
  const status = ref()
  // 获取缓存表数据
  const { load: queryAccountInfo, onResult: accountInfoResult } = useLazyQuery(queryApi.clientFormDraftAll)
  const { load: queryImmigrantAccountInfo, onResult: ImmigrantaccountInfoResult } =
  useLazyQuery(queryApi.clientFormDraftAllByOpenImmigrantAccount)

  // 组装缓存表用户数据
  const formatInfo = (result: any) => {
    let landInfo = {}
    let othersInfo = {}
    let common = {}
    Object.keys(result).forEach(item => {
      if (result[item].data.meta.startsWith('land')) {
        const content = JSON.parse(result[item].data.content)
        landInfo = { ...landInfo, ...content }
      } else if (result[item].data.meta.startsWith('others')) {
        const content = JSON.parse(result[item].data.content)
        othersInfo = { ...othersInfo, ...content }
      } else {
        const content = JSON.parse(result[item].data.content)
        common = content
      }
    })
    store.commit(types.OPEN_INFO_LAND, { info: landInfo })
    store.commit(types.OPEN_INFO_OTHERS, { info: othersInfo })
    store.commit(types.OPEN_COMMON, { info: common })
    storage.set('formType', type)
    isShowView.value = true
    if (from === Form.HOME) {
      if (formName.value === RouterName.TRANSFER_STEP && status.value === OpenStatus.SUPPLEMENT) {
        router.push({ name: formName.value, query: { type, hide: 'hide' } })
      } else {
        router.push({ name: formName.value, query: { type } })
      }
    }
  }

  accountInfoResult((res) => {
    formatInfo(res.data)
  })

  ImmigrantaccountInfoResult((res) => {
    formatInfo(res.data)
  })

  return {
    queryAccountInfo,
    queryImmigrantAccountInfo,
    formName,
    isShowView,
    status
  }
}
